var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A60",
    d: "M3.134 4.666h9.733a.277.277 0 00.263-.364C12.556 2.555 10.45 1.333 8 1.333c-2.448 0-4.555 1.222-5.13 2.97a.278.278 0 00.264.363z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBA6F",
    d: "M14.25 14.667a.417.417 0 000-.833h-.269a.278.278 0 01-.238-.135l-.505-.841a.278.278 0 00-.238-.135H3a.277.277 0 00-.238.135l-.505.84a.279.279 0 01-.238.136H1.75a.417.417 0 000 .833h12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A60",
    d: "M4.389 8H3.278A.278.278 0 003 8.278v3.61c0 .154.124.279.278.279h1.11a.278.278 0 00.279-.278V8.278A.278.278 0 004.389 8zM7.167 8H6.056a.278.278 0 00-.278.278v3.61c0 .154.124.279.278.279h1.11a.278.278 0 00.278-.278V8.278A.278.278 0 007.167 8zM9.944 8h-1.11a.278.278 0 00-.278.278v3.61c0 .154.124.279.277.279h1.111a.278.278 0 00.278-.278V8.278A.278.278 0 009.944 8zM12.722 8h-1.11a.278.278 0 00-.279.278v3.61c0 .154.125.279.278.279h1.111a.278.278 0 00.278-.278V8.278A.278.278 0 0012.722 8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBA6F",
    d: "M2.395 7.064a.556.556 0 00.527.38h10.156a.556.556 0 00.527-.38l.37-1.111a.555.555 0 00-.527-.731H2.551a.556.556 0 00-.526.73l.37 1.112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxesActive);
export default __webpack_public_path__ + "static/media/taxes-active.cececdcae48edba0f000b830d4e66cca.svg";
export { ForwardRef as ReactComponent };